<template>
  <div class="b-island uk-inline">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'b-island'
}
</script>

<style scoped>
.b-island {
  position: relative;
  padding: 25px 40px 25px 40px;
  font-size: 0.875rem;
  box-sizing: border-box;
  border-radius: 10px;
  background: #ffffff;
}
</style>
